import React, { useMemo } from "react";
import { ArticlesIcon } from "../../icons";
import { useConfig } from "../../providers/config_provider";
import type { Article } from "../../types";
import { SearchArticle } from "../content/article";
import SearchSection from "../section";

export default function SearchSuggestionsArticles() {
  const { suggestedArticles, organization } = useConfig();
  const { strings } = organization;
  const { featuredArticlesHeader } = strings;

  const articles = useMemo(() => {
    return suggestedArticles?.map((article, index) => ({
      ...article,
      rank: index + 1,
      type: "featured_article",
    }));
  }, [suggestedArticles]);

  return (
    <SearchSection
      icon={ArticlesIcon}
      title={featuredArticlesHeader}
      meta="articles"
    >
      {articles?.map((article: Article) => (
        <SearchArticle
          key={article.href}
          article={article}
        />
      ))}
    </SearchSection>
  );
}
